

import React, { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import { ApiUrl } from "../../Constants/Weburl";
import "../../CssPage/Livesettings.css";
import SettingSidebar from "../../components/Setttingsidebar";
import CustomContainer from "../../components/Customsettingscontain";
import CustomCard from "../../components/Customsettingscard";
import CustomInput from "../../components/Custominput";
import CustomButton from "../../components/CustomButton";
import CustomSwitch from "../../components/Customswitch";
import Layout from "../../components/Layout";
import SettingsPageShell from "../../components/SettingsMenu";

export default function AppSettings() {

    const [settings, setSettings] = useState(null);

    const [watermarkImage, setWatermarkImage] = useState(null);
    const [watermarkPreview, setWatermarkPreview] = useState("");


    const [loading, setLoading] = useState(true);

    const [saving, setSaving] = useState(false);
    const [saved, setSaved] = useState(false);


    useEffect(() => {
    fetchSettings();
}, []);

    const fetchSettings = async () => {
    try {
        const token = localStorage.getItem("adminToken");

        const res = await axios.get(
            `${ApiUrl}api/getsettingsapp`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        console.log("APP SETTINGS:", res.data);

        if (res.data.success) {
            const data = res.data.data;

            setSettings(data);

            if (data?.watermarkImage) {
                setWatermarkPreview(
                    `${ApiUrl}api/getsettingsapp/${data.watermarkImage}`
                );
            }
        }

    } catch (err) {
        console.log("fetchSettings error:", err);
    } finally {
        setLoading(false);
    }
};


    const saveSettings = async () => {
        try {
            setSaving(true);

            const token = localStorage.getItem("adminToken");

            const formData = new FormData();

            formData.append(
                "minCoinsToWithdraw",
                settings?.minCoinsToWithdraw ?? ""
            );
            formData.append(
                "helpEmail",
                settings?.helpEmail || ""
            );

            formData.append(
                "allowWithdrawal",
                settings?.allowWithdrawal ? "true" : "false"
            );

            formData.append(
                "registrationBonusStatus",
                settings?.registrationBonusStatus
                    ? "true"
                    : "false"
            );

            formData.append(
                "registrationBonusAmount",
                settings?.registrationBonusAmount ?? 0
            );

            formData.append(
                "watermarkVideos",
                settings?.watermarkVideos
                    ? "true"
                    : "false"
            );

            if (watermarkImage) {
                formData.append(
                    "watermarkImage",
                    watermarkImage
                );
            }

            const res = await axios.post(
                `${ApiUrl}api/postsettingsapp`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            console.log("SAVE APP SETTINGS:", res.data);

            if (res.data.success) {

                setSettings(res.data.data);

                if (res.data.data?.watermarkImage) {
                    setWatermarkPreview(
                        `${ApiUrl}appsettingswatermark/${res.data.data.watermarkImage}`
                    );
                }

                setWatermarkImage(null);

                setSaved(true);

                setTimeout(() => {
                    setSaved(false);
                }, 2000);
            }

        } catch (err) {
            console.log(
                "saveSettings error:",
                err.response?.data || err
            );
        } finally {
            setSaving(false);
        }
    };



    return (
      
          
                 <Layout>
                  
                      <SettingsPageShell
             wrapperClassName="rr-wrapper-live"
      >
                      
                      {loading ? (
                    <div className="ls-wrapper">
                        <p>Loading...</p>
                    </div>
                ) : (

                        <div className="ls-wrapper">

                            <div className="ls-section-title">App Settings</div>

                            <div className="ls-note">
                                <p>*Make sure to set coin value according to your currency.</p>
                                <p>*Users can use withdrawal functions only if it the switch is on below.</p>
                            </div>

                            <div className="ls-grid-3">
                                <CustomCard className="ls-card">
                                    <CustomInput
                                        label="Min. Coins To Withdraw"
                                        wrapperClassName=""
                                        labelClassName="ls-label"
                                        type="number"
                                        className="ls-input"
                                        value={settings?.minCoinsToWithdraw ?? ""}
                                        onChange={(e) =>
                                            setSettings({ ...settings, minCoinsToWithdraw: Number(e.target.value) })
                                        }
                                    />
                                </CustomCard>

                                <CustomCard className="ls-card">
                                    <CustomInput
                                        label="Help Email"
                                        wrapperClassName=""
                                        labelClassName="ls-label"
                                        type="email"
                                        className="ls-input"
                                        value={settings?.helpEmail}
                                        onChange={(e) =>
                                            setSettings({ ...settings, helpEmail: e.target.value })
                                        }
                                    />
                                </CustomCard>

                                <CustomCard className="ls-card">
                                    <label className="ls-label">Allow Withdrawal Of Coins</label>
                                    
                                    <CustomSwitch
                                        checked={Boolean(settings?.allowWithdrawal)}
                                      
                                        onChange={(e) =>
                                            setSettings({
                                                ...settings,
                                                allowWithdrawal: e.target.checked,
                                            })
                                        }
                                    ></CustomSwitch>
                                </CustomCard>
                            </div>

                            <div className="ls-section-title" style={{ marginTop: 30 }}>
                                Reward Settings
                            </div>


                            <div className="ls-grid-2">
                                <CustomCard className="ls-card">
                                    <label className="ls-label">Registration Bonus Status</label>
                                   
                                    <CustomSwitch
                                        checked={Boolean(settings?.registrationBonusStatus)}
                                        onChange={(value) =>
                                            setSettings({
                                                ...settings,
                                                registrationBonusStatus: value,
                                            })
                                        }
                                    />
                                </CustomCard>

                                <CustomCard className="ls-card">
                                   
                                    <CustomInput
                                        label="Registration Bonus Amount (Coins)"
                                        wrapperClassName=""
                                        labelClassName="ls-label"
                                        type="number"
                                        className="ls-input"
                                        value={settings?.registrationBonusAmount ?? ""}
                                       
                                        onChange={(e) =>
                                            setSettings({
                                                ...settings,
                                                registrationBonusAmount: Number(e.target.value),
                                            })
                                        }
                                        placeholder="----------"
                                    />
                                </CustomCard>
                            </div>


                            <div className="ls-section-title" style={{ marginTop: 30 }}>
                                WATERMARK SETTINGS

                            </div>


                            <div className="ls-grid-2">
                                <CustomCard className="ls-card">
                                    <label className="ls-label">Watermark Videos</label>
                                   
                                    <CustomSwitch
                                        checked={Boolean(settings?.watermarkVideos)}
                                        onChange={(value) =>
                                            setSettings({
                                                ...settings,
                                                watermarkVideos: value,
                                            })
                                        }
                                    />
                                </CustomCard>

                                <CustomCard className="ls-card">

                                    <CustomInput
                                        label="Watermark Image"
                                        labelClassName="ls-label"
                                        type="file"
                                        accept="image/*"
                                        className="ls-input"
                                        onChange={(e) => {

                                            const file = e.target.files[0];

                                            if (!file) return;

                                            setWatermarkImage(file);

                                            setWatermarkPreview(
                                                URL.createObjectURL(file)
                                            );
                                        }}
                                    />
                                    {watermarkPreview && (
                                        <div className="image-preview">
                                            <img
                                                // src={watermarkPreview}
                                                 src={`${ApiUrl}appsettingswatermark/${settings.watermarkImage}`}
                                                alt="Watermark"
                                                style={{
                                                    maxWidth: "200px",
                                                    maxHeight: "100px",
                                                    objectFit: "contain",
                                                }}
                                            />
                                        </div>
                                    )}
                                </CustomCard>
                            </div>

                            {/* Save Button */}
                            <CustomButton
                                className="ls-save-btn"
                                onClick={saveSettings}
                                disabled={saving}
                            >
                                {saving ? "Saving..." : saved ? "Saved!" : "Save Settings"}
                            </CustomButton>

                        </div>
                                )}
              
                </SettingsPageShell>
            </Layout>
       
    );
}
